<template>
    <div>
        <div class="row">
            <div class="col-12">
                <g-table-sync
                    :app="app"
                    :view="view"
                    :columns="columns"
                    :default-limit="20"
                    pagination="loadmore"
                    @edit="openForm"
                >
                    <template slot="article" slot-scope="{ item }">
                        <span>{{ item.article.name }}</span>
                    </template>

                    <template slot="quantity" slot-scope="{ item }">
                        <span>{{ item.quantity || 0 }}</span>
                    </template>

                    <template slot="expiration_date" slot-scope="{ item }">
                        <span>{{ item.expiration_date }}</span>
                    </template>

                    <template v-if="$gestios.auth.check({ scopes: ['_BOSS'] })" slot="head-left">
                        <div class="ml-3" />
                        <a-upload
                            name="lotFile"
                            accept="text/plain"
                            :multiple="false"
                            :custom-request="importLots"
                            :show-upload-list="false"
                        >
                            <a-button> <a-icon type="upload" /> Importar </a-button>
                        </a-upload>
                    </template>
                </g-table-sync>
            </div>
        </div>

        <custom-form :id="id" ref="form" :visible="formEnabled" @close="closeForm" />

        <a-modal
            :visible="!!lineErrors"
            title="Errores"
            width="800px"
            cancel-text="Cerrar"
            @ok="cleanErrors"
            @cancel="cleanErrors"
        >
            <p>A continuación se muestran las lineas que han arrojado error:</p>
            <a-textarea :value="lineErrors" :disabled="true" :rows="8" />

            <template slot="footer">
                <a-button key="back" @click="cleanErrors"> Cerrar </a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import customForm from './form'

const FormData = require('form-data')

export default {
    name: 'Lots',
    components: { customForm },
    data() {
        return {
            app: 'lots',
            view: 'lotList',
            columns: [
                {
                    title: 'ID',
                    index: '_EntityId',
                    order: true,
                    search: true,
                },
                {
                    title: 'Artículo',
                    index: 'article',
                    order: true,
                    search: false,
                    slot: 'article',
                },
                {
                    title: 'Alta',
                    index: '_EntityCreateDate',
                    order: true,
                    slot: '_datetime',
                },
                {
                    title: 'Código',
                    index: 'name',
                    order: true,
                    search: true,
                },
                {
                    title: 'Cantidad',
                    index: 'quantity',
                    order: true,
                    slot: 'quantity',
                },
                {
                    title: 'Fecha de caducidad',
                    index: 'expiration_date',
                    order: true,
                    slot: '_date',
                    date: true,
                    search: false,
                },
                {
                    title: 'Acciones',
                    width: '190px',
                    slot: '_actions',
                },
            ],
            formEnabled: false,
            lineErrors: null,
            fileUploading: null,
            id: 0,
        }
    },
    created() {
        this.$hub.$on('newLot', () => {
            this.id = 0
            this.formEnabled = true
        })
    },
    beforeDestroy() {
        this.$hub.$off('newLot')
    },
    methods: {
        openForm(item) {
            this.id = item._EntityId
            this.formEnabled = true
        },
        closeForm() {
            this.id = 0
            this.formEnabled = false
        },
        async importLots(params) {
            this.fileUploading = this.$message.loading('Importando fichero de lotes...', 0)

            const form = new FormData()
            form.append('lotFile', params.file, params.file.name)

            const upload = await this.$lambda.post('lots/import', form)

            if (upload.ok) {
                const { success } = upload.data
                const { errors } = upload.data

                if (errors.length > 0) {
                    this.$message.error(
                        `${errors.length} registros de ${errors.length + success.length} no han podido ser importados`
                    )

                    this.lineErrors = errors.join('\n')
                } else {
                    this.$message.success(`Se ha importado correctamente el fichero: ${params.file.name}`)
                }
            } else {
                this.$message.error(upload.message)
            }

            this.fileUploading()
            this.fileUploading = null
        },
        cleanErrors() {
            this.lineErrors = null
        },
    },
}
</script>

<style lang="scss"></style>
